<div class="outer">
  <div class="header">
    {{ heading }}
  </div>

  <div class="list-section">
    <div *ngFor="let exp of list"
      class="exp-item"
      [ngClass]="{'active': (exp.name == activate)}"
      (click)="experienceSelected(exp)">
      <span class="exp-text">{{ exp.value }}</span>
      <i *ngIf="exp.name == activate" class="fas fa-check check-icon"></i>
    </div>
  </div>

  <div class="button-section">
    <button class="cancel" (click)="cancel()">Cancel</button>
    <button class="submit" [disabled]="!activate" (click)="saveExperience()">Select</button>
  </div>
</div>